import { isLength } from '../../../../../../../../../../lib/util/helpers';
import { ChapterState } from '../../../../../../../../../../lib/models/TemplateTypes';
import { getChapterImageUrl } from '../../../../../../utils/rules/chapters_rules_engine_helper';
import { useVariables } from 'src/processes/CMS/processes/management/pages/PreviewPage/hooks/useVariables';

import styles from './styles.module.scss';
import { Typography } from 'antd';
import { ArrowRight } from '../../../../../../../../../../ui/icons/ArrowRight';
import { CheckmarkIcon } from '../../../../../../../../../../ui/icons/CheckmarkIcon';
import { ButtonOrLinkComponent } from '../../../../components/ButtonOrLinkComponent';
import { useWindowResize } from '../../../../../../utils/hooks/useWindowResize';
import { getDisplayedProduct } from './utils';
import { Card } from './Card/Card';

const FIRST_CHAPTER_INDEX = 0;
const MOBILE_WIDTH = 400;

// eslint-disable-next-line max-lines-per-function
export function FirstChapter({
  fonts,
  pagesFlow,
  setPagesFlow,
  style,
  media,
  chapterIconMedia,
  chapterOnClick,
  setPageHistory,
  imageSelectionFlow,
  currentElements,
  animationPhase,
}) {
  const { applyVariable } = useVariables(pagesFlow);
  const { allChapters } = pagesFlow;

  const allChaptersWithoutCompletedChapters = allChapters.filter(item => !item.content.completedChaptersButtons);
  const firstChapter = isLength(allChaptersWithoutCompletedChapters) ? allChaptersWithoutCompletedChapters[FIRST_CHAPTER_INDEX] : {};

  const {
    content: { headline, chapterButton, selectBackgroundImageInactive, selectBackgroundImageActive, selectChapterIcon } = {},
    flow,
    state,
    chapterInnerPagesIds,
    id: firstChapterId,
    rules,
    resultSelectedProducts,
    content,
  } = firstChapter;

  const { windowWidth } = useWindowResize();
  const { firstChapterHeadlineStyle = {}, firstChapterButtonStyle = {} } = style;

  const isBorderAnimation = animationPhase === 'border';
  const isImageAnimation = animationPhase === 'image';

  const backgroundImageUrl = getChapterImageUrl(
    firstChapterId,
    state,
    imageSelectionFlow,
    selectBackgroundImageActive,
    selectBackgroundImageInactive,
    media
  );

  const chapterIcon = chapterIconMedia.find(el => el.id === selectChapterIcon?.value);
  const displayedProduct = getDisplayedProduct(resultSelectedProducts, content?.productsPriority);

  const shouldShowImage = (displayedProduct || isImageAnimation) && chapterIcon;

  const isClickable = [ChapterState.COMPLETED, ChapterState.OPENED].includes(state);
  const isCompleted = state === ChapterState.COMPLETED;

  const handleClick = () => {
    if (isClickable) {
      chapterOnClick(firstChapterId, flow, rules, state, chapterInnerPagesIds[0], 1);
    }
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter' && isClickable) {
      handleClick();
    }
  };

  if (Object.keys(firstChapter).length === 0) return null;

  return (
    <div
      tabIndex={0}
      className={`${styles.firstChapter} ${isClickable ? styles.clickable : ''}`}
      data-testid='first_chapter'
      role='button'
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      <div className={styles.leftContent}>
        {headline && (
          <div className={styles.headlineWrapper}>
            <div className={styles.checkmark}>
              <CheckmarkIcon width={16} height={13} fill='#fff' />
            </div>
            <Typography.Title
              level={3}
              ellipsis={{ rows: 2 }}
              className={styles.headline}
              style={{
                fontSize: fonts.headlineFirst.fontSize,
                fontFamily: fonts.headlineFirst.font,
                fontWeight: fonts.headlineFirst.fontWeight,
                ...firstChapterHeadlineStyle,
                color: '#fff',
                marginBottom: 0,
              }}
            >
              {applyVariable(headline.value)}
            </Typography.Title>
          </div>
        )}

        <Card
          state={state}
          chapterIcon={chapterIcon?.s3Url}
          shouldShowImage={shouldShowImage}
          isBorderAnimation={isBorderAnimation}
          isImageAnimation={isImageAnimation}
        />
        {chapterButton && !isCompleted && (
          <ButtonOrLinkComponent
            analyticsClass='analytics-button'
            contentObject={chapterButton}
            style={{
              minHeight: 48,
              marginTop: 30,
              background: 'transparent',
              marginBottom: 10,
              border: '1px solid rgba(255, 255, 255, 1)',
              borderRadius: 37,
              color: '#fff',
              position: 'relative',
              letterSpacing: 0,
              ...firstChapterButtonStyle,
            }}
            setPagesFlow={setPagesFlow}
            pagesFlow={pagesFlow}
            textStyle={{
              fontFamily: fonts.body.font,
              fontSize: '17px',
              lineHeight: '18px',
              fontWeight: 'bold',
            }}
            setPageHistory={setPageHistory}
            currentElements={currentElements}
          >
            <ArrowRight />
          </ButtonOrLinkComponent>
        )}
      </div>

      {windowWidth > MOBILE_WIDTH && (
        <div className={styles.rightImageWrapper}>
          {backgroundImageUrl ? (
            <img src={backgroundImageUrl} alt='Chapter background' className={styles.rightImage} loading='lazy' draggable={false} />
          ) : null}
        </div>
      )}
    </div>
  );
}
